import { createMuiTheme } from '@material-ui/core'
import { themeConstructor } from './themeConstructor'
import { orangePalette as palette } from '../palettes'

export const primaryTheme = createMuiTheme({
  ...themeConstructor(palette), // default theme
  palette, // override color schema
})
